export default {
  superDesktop: 'सुपर एडमिन पैनल',
  home: 'घर',
  people: 'लोग',
  directory: 'निर्देशिका',
  lists: 'सूचियाँ',
  roles: 'भूमिकाओं',
  segments: 'क्षेत्रों',
  businesses: 'व्यवसायों',
  talk: 'बात',
  chats: 'चैट',
  conversationMetrics: 'मैट्रिक्स',
  conversationSettings: 'चैट कॉन्फ़िगरेशन',
  communicate: 'संवाद',
  campaigns: 'अभियान',
  triggers: 'ट्रिगर्स',
  notifications: 'सूचनाएँ',
  connect: 'जोड़ना',
  authenticator: 'प्रमाणक',
  forms: 'प्रपत्र',
  oAuths: 'ऑथ्स',
  crm: 'Crm',
  /* events */
  events: 'घटनाओं',
  myEvents: 'मेरी घटनाएं',
  categories: 'श्रेणियाँ',
  assistants: 'सहायकों',
  promotors: 'प्रमोटर',
  djs: 'Djs',
  productsCategories: 'उत्पाद श्रेणियाँ',
  products: 'उत्पादों',
  productsSales: 'उत्पादों की खरीदारी',
  clients: 'ग्राहकों',
  colors: 'रंग',
  containerTypes: 'कंटेनर प्रकार',
  purchases: 'खरीद',
  sellers: 'विक्रेताओं',
  suppliers: 'आपूर्तिकर्ताओं',
  microSites: 'माइक्रो साइट्स',
  configure: 'कॉन्फ़िगर',
  generalities: 'सामान्योक्तियां',
  apps: 'Apps',
  administrators: 'व्यवस्थापक',
  billing: 'बिलिंग',
  graphicAspect: 'ग्राफिक पहलू',
  automate: 'स्वचालित',
  following: 'निम्नलिखित',
  mainTables: 'मुख्य टेबल',
  panel: 'पैनल',
  journeyLeads: 'यात्रा का मार्ग',
  sequences: 'दृश्यों',
  userConfiguration: 'उपयोगकर्ता कॉन्फ़िगरेशन'
}
